import { create } from "zustand";

export const useStoreCoachAi = create((set, get) => ({
  transcript: null,
  reportData: {},
  // reportData: {
  //   totalScore: 8,
  //   positiveHighlights: [
  //     "The rep attempted to ask open-ended questions to understand the prospect's needs.",
  //     "The rep made an effort to clarify the prospect's current solution usage.",
  //   ],
  //   areasForImprovement: [
  //     "Improve clarity and structure of the introduction and value hook.",
  //     "Ensure to uncover and acknowledge specific pain points early in the call.",
  //   ],
  //   scorecards: [
  //     {
  //       id: "q1",
  //       question: "Did the rep get permission to proceed quickly?",
  //       type: "yes_no",
  //       score: 0,
  //       answer: "No",
  //       positiveHighlights: [
  //         "The call started with a greeting, although permission was not explicitly sought.",
  //       ],
  //       areasForImprovement: ["Ensure to ask for permission to proceed within the first 45 seconds."],
  //     },
  //     {
  //       id: "q2",
  //       question: "Rate the clarity of the intro and value hook.",
  //       type: "score_5",
  //       score: 2,
  //       answer: "",
  //       positiveHighlights: ["The rep used a greeting at the beginning of the call."],
  //       areasForImprovement: [
  //         "Include a clear and concise value hook in the introduction.",
  //         "Avoid interruptions and ensure the introduction is structured.",
  //       ],
  //     },
  //     {
  //       id: "q3",
  //       question: "How many open-ended questions before the 'ask'?",
  //       type: "score_5",
  //       score: 2,
  //       answer: "",
  //       positiveHighlights: [
  //         "The rep asked open-ended questions to explore the prospect's current solution.",
  //       ],
  //       areasForImprovement: [
  //         "Increase the number of open-ended questions to better understand the prospect's needs.",
  //       ],
  //     },
  //     {
  //       id: "q4",
  //       question: "Did the rep uncover a concrete pain quickly?",
  //       type: "yes_no",
  //       score: 0,
  //       answer: "No",
  //       positiveHighlights: ["The rep attempted to understand the prospect's current challenges."],
  //       areasForImprovement: [
  //         "Focus on identifying and acknowledging specific pain points early in the conversation.",
  //       ],
  //     },
  //     {
  //       id: "q5",
  //       question: "Was the solution positioned to that pain (brief \u0026 relevant)?",
  //       type: "score_5",
  //       score: 1,
  //       answer: "",
  //       positiveHighlights: [],
  //       areasForImprovement: ["Ensure the solution is directly connected to the identified pain points."],
  //     },
  //     {
  //       id: "q6",
  //       question: "What objections came up?",
  //       type: "score_5",
  //       score: 0,
  //       answer: "",
  //       positiveHighlights: [],
  //       areasForImprovement: [],
  //     },
  //     {
  //       id: "q7",
  //       question: "How well were objections handled?",
  //       type: "score_5",
  //       score: 1,
  //       answer: "",
  //       positiveHighlights: [],
  //       areasForImprovement: [
  //         "Improve the handling of objections by following the acknowledge-answer-check back framework.",
  //       ],
  //     },
  //     {
  //       id: "q8",
  //       question: "Did the rep qualify Authority and Timing (light BANT)?",
  //       type: "yes_no",
  //       score: 0,
  //       answer: "No",
  //       positiveHighlights: [],
  //       areasForImprovement: ["Attempt to qualify the prospect's authority and timing for decision-making."],
  //     },
  //     {
  //       id: "q9",
  //       question: "Did the rep secure a micro-commit next step?",
  //       type: "yes_no",
  //       score: 0,
  //       answer: "No",
  //       positiveHighlights: [],
  //       areasForImprovement: ["Secure a micro-commitment for the next step before ending the call."],
  //     },
  //     {
  //       id: "q10",
  //       question: "What was the talk-to-listen ratio?",
  //       type: "score_5",
  //       score: 2,
  //       answer: "",
  //       positiveHighlights: [],
  //       areasForImprovement: [
  //         "Balance the talk-to-listen ratio to ensure more listening and engagement with the prospect.",
  //       ],
  //     },
  //   ],
  // },

  setReportData: (data) =>
    set({
      reportData: data,
    }),
  setTranscriptData: (data) =>
    set({
      transcript: data,
    }),
}));
